export {
  default as boxen,
  type Options as BoxenOptions,
  type Boxes,
  type CustomBorderStyle,
  type Spacing,
} from 'boxen'
